import { Link, Typography } from '@mui/material';
import { SignUpForm, SignUpSuccess } from '@parsys/frontend_library';
import React, { useState } from 'react';

import i18n from 'FRONTEND/utils/i18n';
import {
  API_SIGN_UP,
} from 'FRONTEND/utils/routes';
import logo from 'SRC/static/images/parsys/logo.png';


const ConsentLabel = () => (
  <Typography variant='body2' color='text.secondary'>
    {i18n._('I accept the ')}
    <Link href='https://parsys.com/politique-de-confidentialite-parsys/' target='_blank' rel='noopener noreferrer'>
      {i18n._('Terms of Service')}
      {i18n._(', the ')}
      {i18n._('Privacy Policy')}
      {i18n._(', and I consent to the ')}
      {i18n._('practice of telemedicine')}
    </Link>
    {i18n._(' as part of my care journey.')}
  </Typography>
);


const SignUp = ({ recaptchaClientKey, tenantId, profileId, rtaServerUrl }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  // i18n translations inside component in order to be translated statefully
  // Not really possible to change language via signup page right now, but this is more future-proof
  const validPhoneExample = `(e.g. 0612345678 ${i18n._('or')} +33612345678)`;
  const DEFAULT_LABELS = {
    last_name: i18n._('Name'),
    first_name: i18n._('First name'),
    gender: i18n._('Gender'),
    birthdate: i18n._('Birthdate'),
    email: i18n._('Email addresses'),
    phone_number: i18n._('Phone number'),
    password: i18n._('Password'),
    confirmPassword: i18n._('Confirm password'),
    submit: i18n._('Create my patient account'),
    alreadyHaveAccount: i18n._('Already have an account?'),
    signIn: i18n._('Sign in'),
    passwordMismatch: i18n._('Passwords do not match'),
    accountExists: i18n._('An account already exists'),
    consentRequired: i18n._('You must accept the terms to continue'),
    phoneInvalid: i18n._('Invalid phone number') + ` ${validPhoneExample}`,
    emailInvalid: i18n._('Invalid email address'),
  };

  const STRENGTH_TEXTS = {
    none: i18n._('No password'),
    very_weak: i18n._('Very weak'),
    weak: i18n._('Weak'),
    fair: i18n._('Fair'),
    good: i18n._('Good'),
    excellent: i18n._('Excellent'),
  };

  const passwordFeedbackLabels = {
    passwordTooShort: i18n._('Password too short'),
    passwordValid: i18n._('Password meets requirements'),
    passwordAddTypes: i18n._('Add all character types (uppercase, lowercase, numbers, special characters)'),
    passwordAdd: i18n._('Add '),
    passwordAddMoreChars: i18n._(' more characters to meet the recommended minimum'),
  };

  return (
    showSuccess ? (
      <SignUpSuccess
        logo={logo}
        message={i18n._('Your account has been created successfully. Please check your email to verify your address and complete your account setup.')}
      />
    ) : (
      <SignUpForm
        handleFetch={fetch}
        onSignInClick={() => {
          window.location.href = '/';
        }}
        labels={DEFAULT_LABELS}
        signUpApiUrl={API_SIGN_UP}
        tenant_id={tenantId}
        profile_id={profileId}
        recaptchaSiteKey={recaptchaClientKey}
        onSubmitSuccess={() => {
          setShowSuccess(true);
        }}
        consentLabel={<ConsentLabel />}
        passwordStrengthTextLabels={STRENGTH_TEXTS}
        passwordFeedbackLabels={passwordFeedbackLabels}
      />
    )
  );
};

export default SignUp;
